<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6709 8.43332C16.9042 8.66665 16.9042 9.03332 16.6709 9.26665L10.0375 15.9C8.93753 17 7.67088 17.6 6.48754 17.6C6.18754 17.6 5.88754 17.5666 5.58754 17.4833C4.42087 17.1666 3.52086 16.2666 3.2042 15.05C2.8042 13.55 3.33754 11.9166 4.68754 10.5666L12.0709 3.18332C13.2709 1.98332 14.9375 2.36663 15.9042 3.3333C17.2209 4.64997 16.8542 6.19997 15.9709 7.0833L8.52087 14.5333C7.53754 15.5166 6.42087 15.45 5.8542 14.8666C5.28754 14.2833 5.22087 13.2 6.2042 12.2L11.2375 7.16663C11.4709 6.9333 11.8375 6.9333 12.0709 7.16663C12.3042 7.39997 12.3042 7.76663 12.0709 7.99997L7.03753 13.0333C6.6042 13.4666 6.53754 13.8833 6.68754 14.05C6.8542 14.2166 7.27087 14.15 7.7042 13.7166L15.1542 6.26665C15.9042 5.51665 15.5875 4.66663 15.0875 4.16663C14.5209 3.59997 13.6042 3.31662 12.9042 4.03329L5.52087 11.4166C4.47087 12.4666 4.03754 13.6833 4.33754 14.7667C4.55421 15.5667 5.13754 16.1666 5.90421 16.3666C6.93754 16.65 8.12088 16.1833 9.22088 15.0833L15.8542 8.44996C16.0709 8.21663 16.4375 8.21665 16.6709 8.43332Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "clipIcon-2",
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>

<style scoped>

</style>
